/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { useFormik } from "formik";
import * as Yup from "yup";
import { PostService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import { toastEmmit } from "../../../Helper/Toastr";
import PhoneInput from "react-phone-input-2";

export default function ContactUs() {
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    // lastName: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email address").required("Required"),
    website: Yup.string(),
    phone: Yup.string().required("Required"),
    message: Yup.string().required("Required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      // lastName: "",
      email: "",
      website: "",
      phone: "",
      message: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // Handle form submission logic here
      PostService(API_URL.CONTACT_US, values).then(
        (res) => {
          console.log(res);
          if (res?.data?.status ) {
            toastEmmit("success", 'Your request has been submited.We will back to you soon..');  
            formik.resetForm() 
          }
          // else( toastEmmit("error", res?.data?.message))
        },
        (err) => {
          console.log(err?.response?.data?.message);
          toastEmmit("error", err?.response?.data?.message)
        }
      );
    },
  });

  return (
    <div className="Gallery-Wraps contact">
      <main>
        {/* main section start    */}
        <section className="parent">
          <section className=" pb-80 Partener photographs">
            <div className="container">
              <div className="row ">
                <div className="row text text-center mt-4">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    <h4 className="text-left second">Contact Us</h4>
                    <p className="w-50">
                      We are here to help. Please get in touch with us using any
                      of the following methods.
                    </p>
                  </div>
                </div>
                <div
                  className="col-xl-6 col-lg-6 col-md-12 text-right m-auto pt-50 col-xl-6 pb-45 mt-0"
                  // data-background="assets/img/blog/contact.png"
                  style={{
                    backgroundImage: "url('assets/img/blog/contact.png')",
                  }}
                >
                  <div className=" d-flex align-items-center justify-content-start justify-content-sm-center">
                    <div className="tp-contact-4__text">
                      <h6 className="main-heading pb-10">
                        Printlific Headquarters
                      </h6>
                      <div className="location pb-20">
                        <a href>Location</a> <br />
                        <span>5767 Major Blvd, Orlando Fl. 32819</span>
                      </div>
                      <div className="call-us pb-20">
                        <a href>Call Us</a> <br />
                        <h5>+1 (917) 386-4948</h5>
                        <span>
                          9:00AM - 5:00PM EST <br /> MONDAY - FRIDAY
                        </span>
                      </div>
                      <div className="Email pb-20">
                        <a href>Email</a> <br />
                        <h5>info@printlific.com</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 text-right  col-xl-6 call-m">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="tp-contact-4__input-box mb-20">
                      <input
                        type="text"
                        placeholder="Full Name"
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div className="error">{formik.errors.name}</div>
                      ) : null}
                    </div>
                    {/* <div className="tp-contact-4__input-box mb-20">
                      <input
                        type="text"
                        placeholder="Last Name"
                        name="lastName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.lastName}
                      />
                      {formik.touched.lastName && formik.errors.lastName ? (
                        <div className="error">{formik.errors.lastName}</div>
                      ) : null}
                    </div> */}
                    <div className="tp-contact-4__input-box mb-20">
                      <input
                        type="text"
                        placeholder="Email"
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="error">{formik.errors.email}</div>
                      ) : null}
                    </div>
                    <div className="tp-contact-4__input-box mb-20">
                      <input
                        type="text"
                        placeholder="Website"
                        name="website"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.website}
                      />
                      {formik.touched.website && formik.errors.website ? (
                        <div className="error">{formik.errors.website}</div>
                      ) : null}
                    </div>
                    <div className="tp-contact-4__input-box mb-20 height-4">
                    <PhoneInput
                                country={"us"}
                                value={formik.values.phone}
                                onChange={(e) => {
                                  const formattedNumber = `+${e.replace(/\D/g, "")}`;
                                  formik.setFieldValue("phone", formattedNumber); 
                                }}
                              /> 
                      {formik.touched.phone && formik.errors.phone ? (
                        <div className="error">{formik.errors.phone}</div>
                      ) : null}
                    </div>
                    <div className="tp-contact-4__input-box mb-20">
                      <textarea
                        className="form-control"
                        id="exampleFormControlTextarea1"
                        rows={5}
                        style={{ borderRadius: 0 }}
                        placeholder="Message"
                        name="message"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.message}
                      />
                      {formik.touched.message && formik.errors.message ? (
                        <div className="error">{formik.errors.message}</div>
                      ) : null}
                    </div>
                    <div className="text-left button-uper">
                      <button type="submit" className="large head banner">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* main section end */}
        {/* main section start    */}
        <section className="parent">
          <section className=" pb-80 Partener photographs">
            <div className="container">
              <div className="row ">
                <div className="col-xl-12 col-lg-12 col-md-12 text-right m-auto  col-xl-12">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9923.407430262798!2d-0.23975515637949166!3d51.55261542068907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2sin!4v1695025904955!5m2!1sen!2sin"
                    width={600}
                    height={450}
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* main section end */}

        <UpperFooterSlider />
      </main>
    </div>
  );
}
